import React from 'react'
import {
	ErrorRefBlock,
	InlinePanel,
	InlinePanelMutedLabel,
	StateParagraph,
} from '../ItineraryImportPage.styles'
import CenteredState from './CenteredState'
import { AlertCircle } from './icons'

interface FailedBodyProps {
	importId: string
	reason?: string
}

const FailedBody: React.FC<FailedBodyProps> = ({ importId, reason }) => {
	const time = `${new Date().toISOString().slice(11, 16)} UTC`
	return (
		<CenteredState
			tone="red"
			icon={<AlertCircle size={40} strokeWidth={1.8} />}
			headline="Something went sideways"
		>
			<StateParagraph>
				Our AI assistant didn't respond in time. Your trip wasn't changed. Give it another go — it
				usually works on the second try.
			</StateParagraph>
			<InlinePanel>
				<InlinePanelMutedLabel>Error reference</InlinePanelMutedLabel>
				<ErrorRefBlock>
					{importId} · {reason ?? 'unknown_error'} · {time}
				</ErrorRefBlock>
			</InlinePanel>
		</CenteredState>
	)
}

export default FailedBody
